module.exports = __webpack_public_path__ + "img/2020pinpai-chengxinjiang.72d308db.png";